<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="500px"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">Paieškos kriterijai</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row>
          <v-col cols="12" md="12">
            <el-simple-table :items="tableItems" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <template>
          <el-button
            title="Atgal"
            :loading="loading"
            @click.native.stop="closeModal()"
            color="secondary"
          />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalCriteria',
  props: {
    value: Boolean,
    loading: Boolean,
    item: Object,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {}
  },
  computed: {
    tableItems() {
      let fields = []
      if (this.item) {
        Object.keys(this.item.criteria_array).map((key) => {
          let obj = {}
          switch (key) {
            case 'representitive_iltu_code':
              obj.title = 'Įgaliotinio ILTU kodas'
              break
            case 'representitive_fiz_code':
              obj.title = 'Įgaliotinio asmens kodas'
              break
            case 'representitive_jur_code':
              obj.title = 'Įgaliotinio juridinis kodas'
              break
            case 'service_iltu_code':
              obj.title = 'Paslaugų teikėjo ILTU kodas'
              break
            case 'service_fiz_code':
              obj.title = 'Paslaugų teikėjo kodas'
              break
            case 'service_jur_code':
              obj.title = 'Paslaugų teikėjo juridinis kodas'
              break
            case 'service_provider_lastname':
              obj.title = 'Paslaugų teikėjo pavardė'
              break
            case 'service_provider_name':
              obj.title = 'Paslaugų teikėjo vardas'
              break
            case 'service_provider_birth_date':
              obj.title = 'Paslaugų teikėjo gimimo data'
              break
            case 'period_to':
              obj.title = 'Periodas iki'
              break
            case 'period_from':
              obj.title = 'Periodas nuo'
              break
            case 'action_code':
              obj.title = 'Paslaugos / veiksmo kodas'
              break
            case 'country_code':
              obj.title = 'Valstybė'
              break
            case 'jur_code':
              obj.title = 'Juridinio asmens kodas'
              break
            case 'lastname':
              obj.title = 'Pavardė'
              break
            case 'name':
              obj.title = 'Vardas'
              break
            case 'birth_date':
              obj.title = 'Gimimo data'
              break
            case 'fiz_code':
              obj.title = 'Asmens kodas (AK)'
              break
            case 'iltu_code':
              obj.title = 'ILTU kodas'
              break
            case 'notarial_code':
              obj.title = 'Notarinio registro numeris'
              break
            case 'mandate_code':
              obj.title = 'Identifikavimo kodas'
              break
            case 'purpose':
              obj.title = 'Duomenų naudojimo tikslas'
              break
            case 'representitive_code':
              obj.title = 'Įgaliotinio kodas'
              break
            case 'action_type':
              obj.title = 'Išrašo tipas'
              break
            case 'customer_fullname':
              obj.title = 'Duomenų gavėjas'
              break
            case 'customer_code':
              obj.title = 'Duomenų gavėjo asmens kodas / ILTU kodas / gimimo data'
              break
            default:
              break
          }
          obj.value = this.item.criteria_array[key]
          fields.push(obj)
        })
        return fields
      } else {
        return []
      }
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped></style>
